import React from 'react';
import { HelperMessage } from '@atlaskit/form';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import UserPicker from '@atlassian/jira-user-picker-next';
import messages from './messages';
import type { Props } from './types';

const ProjectLead = (props: Props) => {
	const {
		onChange,
		projectLeadAccountId,
		intl: { formatMessage },
	} = props;
	return (
		<>
			{projectLeadAccountId && (
				<>
					<UserPicker
						labelMessage={formatMessage(messages.projectLeadFieldLabel)}
						isMulti={false}
						value={[projectLeadAccountId]}
						onChange={onChange}
						isClearable={false}
						maxUsers={20}
						fieldId="project-lead-user-picker"
						ariaDescribedBy="settings-project-lead-user-picker"
					/>
					<div id="settings-project-lead-user-picker">
						<HelperMessage>{formatMessage(messages.projectLeadHelpText)}</HelperMessage>
					</div>
				</>
			)}
		</>
	);
};
export { ProjectLead };

export default injectIntl(ProjectLead);
